import { FunctionField, ReferenceManyField, Tab, TabProps, TextField } from 'react-admin';
import { EditOutlined } from '@mui/icons-material';
import { Button, Tooltip } from '@mui/material';
import startCase from 'lodash/startCase';
import { ActionButton } from '@/components/buttons';
import OrderFactLines, { CheckTitle } from '@/pages/Candidate/view/oneOffOrder/OrderFactLines';
import ReportLink from '@/pages/Candidate/view/oneOffOrder/ReportLink';
import { rowLinkSx } from '@/pages/Candidate/view/oneOffOrder/rowLink';
import ViewInVendor from '@/pages/Candidate/view/oneOffOrder/ViewInVendor';
import { MainDatagridStyled } from '@/styles/overrides';
import { OneOffCheckRecord } from '@/types/turn-api';
import { TurnReferencesEnum, TurnTargetsEnum } from '@/types/turn-enums';
import { path, SORT_OPTIONS } from './constants';
import RequestOneOffCheck from './RequestOneOff';
import { ActionButtonStyled, CheckNameContainer, RowActions } from './styled';
import useController from './useController';

const OneOffChecksTab = (props: Partial<TabProps>) => {
  const { checks, closeForm, handleOnEdit, openForm, record, setRecord, showForm, worker } = useController();

  return (
    <Tab label="Custom Checks" {...props}>
      {showForm ? (
        <RequestOneOffCheck
          checks={checks}
          onClose={closeForm}
          onRecordChange={setRecord}
          record={record}
          worker={worker}
        />
      ) : (
        <>
          <ActionButtonStyled iconType="addCircleOutline" label="Request Custom Check" onClick={openForm} />

          <ReferenceManyField
            label=""
            reference={TurnReferencesEnum.Candidates}
            sort={SORT_OPTIONS}
            target={TurnTargetsEnum.OneOffChecks}
          >
            <MainDatagridStyled bulkActionButtons={false} rowClick={false}>
              <FunctionField
                label="Check"
                render={(record: OneOffCheckRecord.Base) => {
                  return (
                    <CheckNameContainer>
                      <CheckTitle>{startCase(record.name)}</CheckTitle>
                      <OrderFactLines source={record} />
                    </CheckNameContainer>
                  );
                }}
              />
              <TextField label="Status" source={path('state')} />
              <TextField label="Resolution" source={path('resolution')} />
              <FunctionField
                label="Report URL"
                sortable={false}
                render={(row: OneOffCheckRecord.Base) =>
                  row.report_url ? (
                    <span style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                      <ViewInVendor source={row} />
                      <Tooltip title={row.report_url}>
                        <span>
                          <ReportLink href={row.report_url} originalName={row.original_file_name} />
                        </span>
                      </Tooltip>
                    </span>
                  ) : null
                }
              />
              <FunctionField
                label="Links"
                sortable={false}
                render={(row: OneOffCheckRecord.Base) => (
                  <RowActions>
                    {row.report_url ? null : <ViewInVendor source={row} />}
                    <Button onClick={() => handleOnEdit(row)} startIcon={<EditOutlined />} sx={rowLinkSx}>
                      Edit Check
                    </Button>
                  </RowActions>
                )}
              />
            </MainDatagridStyled>
          </ReferenceManyField>
        </>
      )}
    </Tab>
  );
};

export default OneOffChecksTab;
